/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';

/* Services */
import { isVisInViewport } from '@components/Utility/Shared/SharedService';
import { isSectionInViewport } from '../../components/Utility/Shared/SharedService';
import { mixPanel } from '@utils/Mixpanel';
import { useRegisterPopupVisibilityContext } from '@landing_pages/margazhi/context/registerPopupVisibilityContext';

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const RegisterButtonSticky = ({ sectionContent, region, lang, pageData }) => {
  const { onOpen } = useRegisterPopupVisibilityContext();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      listenToScroll();
    }, 1000);
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const listenToScroll = () => {
    const bannerDiv = document.getElementById('banner');
    const margazhiRegisterBtns = document.querySelectorAll('#register-button');
    const registerSection = document.getElementById('register-section');
    const footerDiv = document.getElementById('footer');

    const inViewPort = bannerDiv && isVisInViewport(bannerDiv);
    
    // Check if any of the register buttons are in viewport
    let inMargazhiBtnViewPort = false;
    if (margazhiRegisterBtns.length > 0) {
      inMargazhiBtnViewPort = Array.from(margazhiRegisterBtns).some(btn => 
        isSectionInViewport(btn, 27) // 27 is half height of the button
      );
    }
    
    const isRegisterSectionViewPort =
      registerSection && isVisInViewport(registerSection);
    const footerInViewPort = footerDiv && isVisInViewport(footerDiv);
    if (
      inMargazhiBtnViewPort ||
      inViewPort ||
      footerInViewPort ||
      isRegisterSectionViewPort
    ) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
    return;
  };

  const mixPanelTrigger = () => {
    const Mixpanel = mixPanel(window?.location.pathname);
    Mixpanel.track('margazhi_register_now_cta_click', {
      cta: 'sticky cta',
      element: 'REGISTER NOW',
    });
  };

  return (
    <>
      {isVisible && (
        <Box
          position="fixed"
          bottom={{ base: '0px', lg: '150px' }}
          zIndex="99"
          right={{ base: '0', lg: '0' }}
          boxSizing="content-box"
          display="flex"
          justifyContent="flex-end"
          className="bottomButton"
          w={{ base: '100%', lg: 'max-content' }}
        >
          <SimpleButton
            scrollPage={false}
            w={{ base: '100%', lg: 'max-content' }}
            minW={{ base: '216px', lg: '242px' }}
            borderRadius={{ base: '0', lg: '32px 0 0 32px !important' }}
            background={'#CF4520 !important'}
            h={{ base: '54px' }}
            textAlign="center"
            mb={'0px'}
            mt="0px"
            mx={{ base: '0', md: '0' }}
            _hover={{
              background: '#AB3312 !important',
            }}
            style={{
              ...sectionContent[0],
              linkUrl: "",
              buttonText: (
                <Box
                  justifyContent={'center'}
                  display="flex"
                  alignItems="center"
                  gap="8px"
                  height={'34px'}
                >
                  <Box
                    className="allSmallCase"
                    lineHeight={'20px'}
                    paddingBottom={'6px'}
                  >
                    {sectionContent[0]?.buttonText}
                  </Box>
                  <Box>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="12"
                      viewBox="0 0 15 12"
                      fill="none"
                    >
                      <path
                        d="M8.21875 0.75L13.4688 5.99999L8.21875 11.25M0.53125 5.99999L13 6"
                        stroke="white"
                        stroke-width="2"
                      />
                    </svg>
                  </Box>
                </Box>
              ),
            }}
            padding={{
              base: '10px 32px',
              lg: '10px',
            }}
            lineHeight={{
              base: '34px',
            }}
            color="#fff"
            fontSize={"22px"}
            fontFamily={"FedraSansStd-medium"}
            letterSpacing={'2.88px'}
            zIndex={100}
            onClick={() => {
              onOpen();
              mixPanelTrigger()
            }}
            textTransform="uppercase"
            cursor="pointer"
            useBlankStringURLOnLink
          />
        </Box>
      )}
      <style jsx global>
        {`
          .bottomButton button {
            width: 100%;
          }
          .allSmallCase {
            font-variant: all-small-caps;
          }
        `}
      </style>
    </>
  );
};

export default RegisterButtonSticky;
